import modals from './LearningManagement_modals';
import employees from './LearningManagement_employees';

export default {
  namespaced: true,
  modules   : {
    modals,
    employees,
  },
  getters: {
    add_training_modal: ({modals}) => modals.find((modal)=> modal.type == 'add_training_modal').active,
  },
  mutations: {
    SHOW_NUMBER(state, obj) {
      const {array, selected} = obj;
      if (selected=='Показывать по 10') {
        state.selected_number = 10;
      } else if (selected=='Показывать по 25') {
        state.selected_number = 25;
      } else if (selected=='Показывать по 50') {
        state.selected_number = 50;
      } else if (selected=='Показывать по 100') {
        state.selected_number = 100;
      }
      if (array.length >= 10) {
        return array.slice(0, state.selected_number);
      } else {
        return array;
      }
    },
    SET_PAGE(state, obj) {
      let {value} = obj;
      let selectedTable = state.tables.find((object)=> object.name === 'users_employees');
      selectedTable.pagination.page = value;
    },
  },

};
